module.exports = __webpack_public_path__ + "img/af.7591ddc7.jpg";